"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PTTFormField = void 0;

var _react = require("informel/react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PTTLayout = require("./PTTLayout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PTTFormField = (0, _styledComponents["default"])(_react.InformField).withConfig({
  displayName: "PTTFormField",
  componentId: "sc-1o0kifr-0"
})(["", " &[error][touched] input:enabled,&[error][touched] textarea:enabled{border-color:var(--blox-red);}"], _PTTLayout.Layout);
exports.PTTFormField = PTTFormField;